import { BOOKED, REMOVED } from "./actionsTypes";

export const book = (destFrom, destTo, journeyDate, guests, flightClass) => {
  return {
    type: BOOKED,
    payload: {
      destFrom,
      destTo,
      journeyDate,
      guests,
      flightClass,
    },
  };
};
export const removed = (id) => {
  return {
    type: REMOVED,
    payload: {
      id,
    },
  };
};
